
import React, { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../../context/GlobalContext';
import { useTranslation } from 'react-i18next';





const DeviceTNC = React.memo(() => {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, selectedAcPlan } = state;
    const win: any = window;
    const serverURL = win['base_portal_url'];
    const { t } = useTranslation();
    const lang = rtl ? 'ar' : 'en';
    const [htmlData, setHTMLData] = useState<any>(null);

useEffect(() => {
    let appleCareTermsUrl = '';
    if (win['env_variable'] === 'PROD') {
        appleCareTermsUrl = `${serverURL}/web/${lang}/devices/terms-and-conditions/coverage-subscription`;
    } else {
        appleCareTermsUrl = `${serverURL}/wps/wcm/connect/${lang}/devices/terms-and-conditions/coverage-subscription`;
    }
    const fetchTerms = async () => {
        try {
            dispatch({ type: "LOADER", payload: { loading: true } });
            const res = await fetch(appleCareTermsUrl);
            const data = await res.text();
            setHTMLData(data);
            // Wait until React renders HTML
            requestAnimationFrame(() => {
                if (selectedAcPlan?.acName.includes("AppleCare+ warranty one time")) {
                    const row: any = document.getElementById('yearly_block');
                    row!.style.display = 'block';

                    const yearly_amount: any = document.getElementById('yearly_payment');
                    const duration: any = document.getElementById('payment_duration');
                    yearly_amount!.innerHTML = ` ${selectedAcPlan?.price}`;
                    duration!.innerHTML = t("two_years_sub");
                }


                if (selectedAcPlan?.acName.includes("AppleCare+ warranty recurring")) {
                    const row: any = document.getElementById('monthly_block');
                    row!.style.display = 'block';

                    const monthly_installment: any = document.getElementById('monthly_installment');
                    monthly_installment!.innerHTML = ` ${selectedAcPlan?.price}`;
                }
            });
        } finally {
            dispatch({ type: "LOADER", payload: { loading: false } });
        }
    };
    fetchTerms();
}, []);

    return (
        <div
            className="DeviceTnC__Content"
            dangerouslySetInnerHTML={{ __html: htmlData || '' }}
        />
    );
});

export default DeviceTNC